import { IInstallmentItem, IInstallments } from "models";

export const mapInstallments: Record<string, (installments: IInstallments, index: number) => IInstallmentItem> = {
  "credit": (installments: IInstallments, index: number) => installments?.credit_card?.[index],
  "debit": (installments: IInstallments, index: number) => installments?.debit_card?.[index],
  "pix": (installments: IInstallments, _) => installments?.pix,
}